import { Injectable, inject } from '@angular/core';
import { Route, Router, RouterState, UrlSegment, UrlTree } from '@angular/router';
import { Helpers } from '../models/helpers';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})

export class AdminUserGuard {

  constructor(
    private authService: AuthService,
    private router: Router,
  ) { }

  isAllowed(permissions: Helpers.Permission[]) {
    const isAllowed = permissions.includes(this.authService.permissionUsed.value);
    if (isAllowed) {

    }
    if (
      !isAllowed &&
      this.authService.permissionUsed.value === Helpers.PermisionScreen &&
      !permissions.includes(Helpers.PermisionScreen)
    ) {
      // Account Screen (monitor magazzino) su una route non sua: mai
      // lasciarlo cadere sul 404 (schermo incustodito) — si rimanda
      // alla sua pagina. NB: solo quando la route NON ammette Screen,
      // altrimenti su /warehouseorders andrebbe in loop.
      this.router.navigate(['/warehouseorders'], { replaceUrl: true });
    }
    if (!isAllowed && (this.authService.permissionUsed.value === Helpers.PermisionNone)) {

      const state: RouterState = this.router.routerState;
      this.router.navigate(['/login'], { replaceUrl: true });

      // setTimeout(() => {
      //   const state: RouterState = this.router.routerState;
      //   this.router.navigate(['/login'], { queryParams: { returnUrl: state?.snapshot?.url } });
      // }, 250);

      // return true;
    }
    return isAllowed;
  }

  canMatch = async (permissions: Helpers.Permission[], permissionService = inject(AdminUserGuard)) => {
    await this.authService.loadToken();
    return permissionService.isAllowed(permissions);
  }

}


